export const apiRoutes = {
  dashboard: '/admin/reporting/dashboards/home',
}
